module.exports = __webpack_public_path__ + "static/media/tabagismo.4010a7f9.jpg";